import { render } from "./CheckoutSuccess.vue?vue&type=template&id=cc5e1c1e"
import script from "./CheckoutSuccess.vue?vue&type=script&lang=js"
export * from "./CheckoutSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/intermagtech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__